import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IUserInfo } from '../../../../ts/models/IUserInfo';
import { Users } from '../../../../ts/resources/Users';
import { ChangeContentOwnerAction } from '../../../../ts/services/ChangeContentOwnerAction';
import { IResultWithTargetOwner } from '../../../../ts/services/ChangeWorkbookOwnerAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetOwnerAction } from '../../../actions/spaces/SetOwnerAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { reloadSpaceIfUpdatingCurrentSpace } from '../content/RefreshContentSagas';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';

export function* handleSetOwner(action: SetOwnerAction): SagaIterator {

  try {
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.items);

    yield call(openSetContentOwnerDialog, mutatableContentCopy);

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.items);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openSetContentOwnerDialog(items: IContentInfo[]): ng.IPromise<IResultWithTargetOwner> {
  const setOwnerService = ServiceLocator.get<ChangeContentOwnerAction>('ChangeContentOwnerAction');
  const context = ServiceLocator.getAngularActionContext();
  return setOwnerService.confirmChangeOwner(items, context);
}

export function getUser(userId: string): ng.IPromise<IUserInfo> {
  const usersResource = ServiceLocator.get<Users>('Users');
  return usersResource.getById(userId);
}
